import { User } from '../user';

/** format:
 * rest_access: {
 *   @COMMON_NAME: "1651751856"
 *   @REL_ATTR: "556480"
 *   @id: "556480"
 *   access_key: 1651751856
 *   contact: { ... }
 *   expiration_date: 1599125755
 *   link: {@href: "http://10.118.122.42:8050/caisd-rest/rest_access/556480", @rel: "self"}
 *   token: "<token>"
 * }
 */

export default class Session {
  constructor(opts = {}) {
    this.id = opts['@id'] || null;
    this.accessKey = opts.access_key || null;
    this.token = opts.token || null;
    this.expirationDate = opts.expiration_date || null;
    this.redirect = opts.redirect || null; // ttp auth

    this.user = null;
    if (opts.contact != null) {
      this.user = new User(opts.contact);
    }

    this.preferences = null;
    if (opts.preferences != null) {
      this.preferences = opts.preferences;
    }

    if (opts.contact != null) {
      this.user.provinceUser = opts.contact.provinceUser || null;
    }
    if (opts.contact != null) {
      this.user.znodoNombre = opts.contact.znodoNombre || null;
      this.user.znodoId = opts.contact.znodoId || null;
    }
  }

  get storage() {
    return {
      access_key: this.accessKey,
      rest_access: this.id,
      token: this.token,
      expirationDate: this.expirationDate,
    };
  }
}

export const formatSession = (data) => {
  if (data.rest_access == null) {
    return null;
  }

  const session = new Session(data.rest_access);

  // [FIX] we need to store the restaccess response
  // to send it to backbone as session:fetch event data
  // this MUST NO BE used in vue app

  // eslint-disable-next-line no-underscore-dangle
  session.__$backbone_restaccess_response__ = { data };

  return session;
};
